import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import * as Highcharts from 'highcharts';
// Models
import { Vehicle, GeneralBatteryInfo, MultipleApiResponse } from '@mocca-technologies/model';
// Services
import { CoreService } from 'src/app/services/core.service';
// Utils
import { environment } from 'src/environments/environment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-maintenance-form',
  templateUrl: './maintenance-form.component.html',
  styleUrls: ['./maintenance-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class MaintenanceFormComponent implements OnInit {

  /**
   * Variables
   */

  selectedMode: 'battery' | 'drone' = "battery";
  selectedBattery: string = "Lila 1"; // CHange to Battery model
  selectedDrone: Vehicle = null;

  selectedBatteryGeneralInfo: GeneralBatteryInfo = null;

  vehicleList: Vehicle[];

  Highcharts: typeof Highcharts = Highcharts;
  droneBatteryUsageChartOptions: Highcharts.Options;
  dateBatteryUsageChartOptions: Highcharts.Options;

  popoverOptions = {
    cssClass: 'popover-style'
  };

  autogrowTextarea = false;

  description: string = '';
  reviewerName: string = '';
  maintenanceDate: Date;
  finalBatteryPercentage: number = 0;
  initialBatteryPercentage: number = 0;

  @Output() maintenanceType = new EventEmitter<'battery' | 'drone'>();

  changeMaintenanceType(event: any) {
    !environment.production && console.log(event.detail.value);
    this.maintenanceType.emit(event.detail.value as 'battery' | 'drone');
  }

  get user() {
      return JSON.parse(localStorage.getItem('user'));
  }

  constructor(private store: Store,
    private coreService: CoreService
  ) {

    this.selectedBatteryGeneralInfo = {
      avFlightConsumption: 70,
      drones: [
        { drone: this.vehicleList.find(vehicle => vehicle.plate === "UPC011"), batteryFrequency: 89 },
        { drone: this.vehicleList.find(vehicle => vehicle.plate === "UPC012"), batteryFrequency: 10 },
      ],
      lastOperations: [],
      preferredDrone: this.vehicleList.find(vehicle => vehicle.plate === "UPC011"),
      loopNumber: 99,
      lastPercentage: 30,
      usageByDate: [
        { date: new Date('2023-01-01'), usedPercentage: 50 },
        { date: new Date('2023-01-02'), usedPercentage: 45 },
        { date: new Date('2023-01-03'), usedPercentage: 60 },
        { date: new Date('2023-01-04'), usedPercentage: 55 },
        { date: new Date('2023-01-05'), usedPercentage: 70 },
        { date: new Date('2023-01-06'), usedPercentage: 65 },
        { date: new Date('2023-01-07'), usedPercentage: 80 },
        { date: new Date('2023-01-08'), usedPercentage: 75 },
        { date: new Date('2023-01-09'), usedPercentage: 90 },
        { date: new Date('2023-01-10'), usedPercentage: 85 },
        { date: new Date('2023-01-11'), usedPercentage: 40 },
        { date: new Date('2023-01-12'), usedPercentage: 35 },
        { date: new Date('2023-01-13'), usedPercentage: 50 },
        { date: new Date('2023-01-14'), usedPercentage: 45 },
        { date: new Date('2023-01-15'), usedPercentage: 60 },
        { date: new Date('2023-01-16'), usedPercentage: 55 },
        { date: new Date('2023-01-17'), usedPercentage: 70 },
        { date: new Date('2023-01-18'), usedPercentage: 65 },
        { date: new Date('2023-01-19'), usedPercentage: 80 },
        { date: new Date('2023-01-20'), usedPercentage: 75 }
      ],
    };

    this.droneBatteryUsageChartOptions = {
      chart: {
        type: 'pie'
      },
      title: {
        text: 'Battery Usage by drones',
        style: {color: 'var(--ion-color-primary)'}
      },
      series: [{
        type: 'pie',
        name: 'Drone battery usage',
        data: this.selectedBatteryGeneralInfo.drones.map(drone => ({
          name: drone.drone.plate,
          y: drone.batteryFrequency
        }))
      }]
    };

    this.dateBatteryUsageChartOptions = {
      chart: {
        type: 'bar'
      },
      title: {
        text: 'Battery Usage by date',
        style: {color: 'var(--ion-color-primary)'}
      },
      xAxis: {
        categories: this.selectedBatteryGeneralInfo.usageByDate.map(register => register.date.toDateString()),
        title: {
          text: null
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Percentage used',
          align: 'high'
        },
        labels: {
          overflow: 'justify',
        }
      },
      legend: {
        enabled: false,
      },
      series: [{
        type: 'bar',
        name: 'Battery Percentage Usage',
        data: this.selectedBatteryGeneralInfo.usageByDate.map(register => register.usedPercentage)
      }]
    };

  }

  ngOnInit() {
    this.coreService.getAllVehicles().subscribe({
      next: (res: HttpResponse<MultipleApiResponse>) => {

        if (res?.status === 204){
          this.vehicleList = [];
          return;
        }

        const vehicles = res?.body?.responseObject as Vehicle[];
        this.vehicleList = vehicles;
        this.selectedDrone = vehicles[0];
      },
      error: (error: HttpErrorResponse) => {
        this.coreService.showServerResponse(error?.status, error?.error);
      }
    });
  }

  /**
   * This method is used when we blur the description text area and returns to the original size, enabling the scroll bar too.
   */
  disableAutogrowTextarea(){
    const textarea = document.querySelector('ion-textarea');
    textarea.style.height = '56px';
    this.autogrowTextarea = false;
  }

  /**
   * This method is used when we focus on the description text area and enables it to expand.
   */
  enableAutogrowTextarea(){
    const textarea = document.querySelector('ion-textarea');
    textarea.style.height = 'auto';
    this.autogrowTextarea = true;
  }

}
